/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import { Grid, Typography, useMediaQuery } from "@mui/material";
import { useEffect, useRef, useState } from "react";
import CarouselComponent from "../../shared/components/reusableComp/CarouselComponent";
import TabViewCarousel from "../../shared/components/reusableComp/TabViewCarousel";
import {
  DESKTOP_VIEW_WIDTH,
  MOBLIE_VIEW_WIDTH,
  TAB_VIEW_WIDTH,
} from "../../shared/constants/constants";
import { useParams } from "react-router-dom";
import {
  getIndustry,
  getIndustryCategory,
  getIndustryTable,
} from "./requestCall";
import MultipleSlidesCarousel from "../../shared/components/reusableComp/MultipleSlidesCarousel";
import ProductTable from "../../shared/components/reusableComp/ProductTable";

const carouselStyle = (matchesDesktop, matchesTab) => css`
  background: #121212;
  scroll-margin-top: ${
    (matchesDesktop && "85px") || (matchesTab && "69px") || "56px"
  };
  height: 50vw,
  min-height: 70vh;
`;

const tableStyle = (matches, matchesDesktop, matchesTab) => css`
  background: #121212;
  padding: ${matches ? "0 100px" : "30px 5px"};
  height: 50vw,
  min-height: 70vh;
  scroll-margin-top: ${
    (matchesDesktop && "90px") || (matchesTab && "69px") || "56px"
  };
`;

const cardCarouselStyle = (matches) => css`
  background: #121212;
  height: 45vw;
  min-height: ${matches ? "50vh" : "70vw"};
  max-height: 70vh;
`;

export default function Industry({ Slug }) {
  const [carouselData, setCarouselData] = useState([]);
  const [cardCarouselData, setCardCarouselData] = useState([]);
  const [tabViewCarouselData, setTabViewCarouselData] = useState([]);
  const [tableRowNames, setTableRowNames] = useState([]);
  const [tableContent, setTableContent] = useState([]);
  const [tableTitle, setTableTitle] = useState("");
  const [cardTitle, setCardTitle] = useState("");
  const [error, setError] = useState("");
  const matchesDesktop = useMediaQuery(DESKTOP_VIEW_WIDTH);
  const matchesTab = useMediaQuery(TAB_VIEW_WIDTH);
  const matches = useMediaQuery(MOBLIE_VIEW_WIDTH);
  const myRef = useRef();
  const tableRef = useRef();
  const { slug } = useParams();

  useEffect(() => {
    slug &&
      getIndustry(slug || Slug)
        .then(({ data }) => {
          document.title = data?.data?.attributes?.title;
          setTableTitle(data?.data?.attributes?.tableTitle);
          setCardTitle(data?.data?.attributes?.cardTitle);
          data?.data?.attributes?.body?.map((item) => {
            if (item.__component === "components.slider") {
              setCarouselData([...item.slides]);
            } else if (item.__component === "components.card-carousel") {
              setCardCarouselData([...item.card]);
            } else if (item.__component === "components.tabs") {
              setTabViewCarouselData([...item.tabs]);
            }
          });
          setError("nothing");
        })
        .catch(() => setError("got"));
  }, [slug]);

  useEffect(() => {
    error === "nothing" &&
      getIndustryCategory().then(({ data }) => {
        setTableRowNames([...data.data]);
      });
  }, [error]);

  useEffect(() => {
    error === "nothing" &&
      getIndustryTable().then(({ data }) => {
        setTableContent([...data.data]);
      });
  }, [error]);

  const handleScroll = () => {
    if (tabViewCarouselData.length > 0)
      myRef.current.scrollIntoView({ behavior: "smooth" });
    else tableRef.current.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <div className="App" style={{ zIndex: "-1", marginTop: "" }}>
      <Grid container style={{ background: "#121212" }}>
        {carouselData.length > 0 && (
          <Grid item xs={12}>
            <CarouselComponent
              carouselData={carouselData}
              handleScroll={handleScroll}
            />
          </Grid>
        )}

        {tabViewCarouselData.length > 0 && (
          <Grid
            ref={myRef}
            item
            css={() => carouselStyle(matchesDesktop, matchesTab)}
            xs={12}
          >
            <TabViewCarousel tabViewCarouselData={tabViewCarouselData} />
          </Grid>
        )}
        {tableContent?.length > 0 && (
          <Grid
            ref={tableRef}
            item
            css={() => tableStyle(matches, matchesDesktop, matchesTab)}
            xs={12}
            mt={tabViewCarouselData.length > 0 ? 2 : 6}
          >
            <Typography
              variant={matches ? "h3" : "h5"}
              style={{ color: "white" }}
              pb={5}
            >
              {tableTitle}
            </Typography>
            <ProductTable
              tableRowNames={tableRowNames}
              tableContent={tableContent}
            />
          </Grid>
        )}
        {cardCarouselData.length > 0 && (
          <Grid
            item
            p={5}
            pr={matches && 25}
            pl={matches && 25}
            mb={10}
            css={() => cardCarouselStyle(matches, matchesTab)}
            xs={12}
          >
            <Typography
              variant={matches ? "h3" : "h5"}
              style={{ color: "white" }}
              pb={5}
            >
              {cardTitle}
            </Typography>
            <MultipleSlidesCarousel
              industryCardData={cardCarouselData}
              cardsPerView={4}
            />
          </Grid>
        )}
      </Grid>
    </div>
  );
}
